var _g, _path, _g2, _path2, _path3, _rect, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#va0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#va-filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22,
    fill: "#053668"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7806 4.93802L4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L31.2194 4.93802C30.5005 4.38501 29.4995 4.38501 28.7806 4.93802Z",
    fill: "#1573DA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#va-filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 42,
    height: 40,
    rx: 1,
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 42,
    height: 40,
    rx: 1,
    fill: "url(#va-paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L37 42H23L4 24Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 24V54C4 55.1046 4.89543 56 6 56H54C55.1046 56 56 55.1046 56 54V24L37 42H23L4 24Z",
    fill: "url(#va-paint1_linear)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 42L53.5503 54.1949C54.3274 54.7676 53.9224 56 52.9571 56H7.04292C6.07761 56 5.67259 54.7676 6.44972 54.1949L23 42H37Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 42L53.5503 54.1949C54.3274 54.7676 53.9224 56 52.9571 56H7.04292C6.07761 56 5.67259 54.7676 6.44972 54.1949L23 42H37Z",
    fill: "url(#va-paint2_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FF8A00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37 25.31C29.37 25.6579 29.652 25.94 30 25.94C30.3479 25.94 30.63 25.6579 30.63 25.31V20.51C30.63 20.1621 30.3479 19.88 30 19.88C29.652 19.88 29.37 20.1621 29.37 20.51V25.31ZM29.214 27.752C29.214 28.1727 29.5263 28.556 30.03 28.556C30.4807 28.556 30.786 28.1651 30.786 27.752C30.786 27.3811 30.4754 26.996 30.03 26.996C29.5317 26.996 29.214 27.3737 29.214 27.752Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "va-filter0_f",
    x: -16,
    y: -16,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "va-filter1_d",
    x: 8.5,
    y: 7.5,
    width: 44,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "va-paint0_linear",
    x1: 30.9545,
    y1: 8,
    x2: 19.0216,
    y2: 44.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "va-paint1_linear",
    x1: 27.5,
    y1: 56,
    x2: 24.45,
    y2: 30.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "va-paint2_linear",
    x1: 29,
    y1: 56,
    x2: 29.0001,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "va0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationEnvelope);
export default __webpack_public_path__ + "static/media/notification-envelope.fdb78647.svg";
export { ForwardRef as ReactComponent };